/**
 * Layout: Verhaal - Quote
 * Slug: verhaal_quote
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.verhaal_quote-layout');

	layouts.forEach((layout) => {
		
	});
});
